export const QUIZ_STAGE_COUNT = 13;
export const QUIZ_STAGE_LOCATION_COUNT = 12;



// WEBPACK FOOTER //
// ./app/constants/praticeQuizStage.js